import React, {Component} from 'react';
import {Button, Drawer, Modal, Popover, Select, Space, Tooltip} from "antd";
import actions from "@redux/EditableTable/actions";
import {connect} from "react-redux";
import {FilterOutlined, PlusOutlined, ReloadOutlined} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import appActions from "@redux/app/actions";
import FunctionalTestingDetail from "@containers/facility/Equipment/FunctionalTesting/FunctionalTestingDetail";
import {api} from "@redux/api";
import { withRouter } from '@/router/withRouter';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';


class FunctionTestingPageHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            value: [],
            filter_dates: [],
            isTemplateSelector:false,
            selectedTypeOption: [{
                key: '',
                value: 'Generic',
                label: 'Blank Template(Default)',
                record: ''
            }],
            tableRef: this.props.tableRef,
            selectedTemplate: '',
        }
    }

    async componentDidMount() {
        let type_data = [], type_options = []
        let equipment_type = this.props.selectedRecord?.category
        let query = ''
        if (equipment_type === undefined) {
            query = ''
        } else {
            query = '&type=' + equipment_type
        }
        const response = await api.filterFunctionalFormView(query);
        type_data = response?.data?.results || [];

        type_options.push({
            key: '',
            value: 'Generic',
            label: 'Blank Template(Default)',
            record: ''
        })

        for (let i = 0; i < type_data.length; i++) {
            type_options.push({
                key: type_data[i].id,
                value: type_data[i].id,
                label: type_data[i].name+' ('+type_data[i].type+')',
                record: type_data[i]
            })
        }

        this.setState({
            type_options,
        })
    }
    handleRefresh = (e) => {
        this.props.handleFresh()
    }

    handleOpenNew = (e) => {
        this.setState({
            // isOpenNew: true,
            isTemplateSelector: true
        })
    }

    onClose = (e) => {
        this.setState({
            isOpenNew: false
        })
    }

    handOnlineSave = async (key, row) => {
        let result = await this.props.createRecords(row);
        // console.log('result', result)
        if (!(result?.response?.status > 299)) {
            this.setState({
                isOpenNew: false
            })
            this.props.handleFresh();
        }
    }

    formRefCallback = (formRef) => {
        // console.log('formRefCallback', formRef)
        this.props.getFormRef(formRef);
    }

    renderDrawer = () => {

        return (
            <>
                <Drawer
                    width={window.innerWidth > 900 ? '90%' : '100%'}
                    placement="right"
                    closable={false}
                    onClose={this.onClose}
                    visible={this.state.isOpenNew}
                    destroyOnClose={true}
                    autoFocus={true}
                >
                    <div>
                         <FunctionalTestingDetail
                                    selectedTemplateType={this.state.selectedTemplateType}
                                    selectedTypeOption={this.state.selectedTypeOption}
                                    selectedRecord={this.props.selectedRecord}
                                    handOnlineSave={this.handOnlineSave}
                                    columnProps={this.props.columnProps}
                                    formClassName={this.props.formClassName}
                                    isNewRecords={true}
                                    onClose={this.onClose}
                                    formRefCallback={this.formRefCallback}
                            />
                    </div>
                </Drawer>
            </>)
    }


    handleOpenFilters = () => {
        this.setState({
            isOpenFilters: true
        })
    }

    handleSearchSelect = (e, record) => {
        let data = record.record;
        console.log('handleSearchSelect', e, record.record)
        this.setState({
            selectedTypeOption: data?.fields,
            selectedTemplate: e,
            selectedTemplateType: data?.type?data.type:'Generic'
        })
    }

    onTemplateSelectorNext = () => {
        const { selectedTemplate } = this.state;
        // If navigate function is provided via props, use route navigation
        if (this.props.navigate) {
            const targetPath = buildFacilityPath("create-functional-testing", {
                companyId: this.props.companyId,
                facilityId: this.props.facilityId,
                query: {
                    templateId: selectedTemplate || undefined,
                    equipmentId: this.props.selectedRecord?.id || undefined,
                },
            }) || "/switch-view";
            this.props.navigate(targetPath);
            this.setState({
                isTemplateSelector: false,
            });
        } else {
            // Fallback to Drawer mode
            this.setState({
                isTemplateSelector: false,
                isOpenNew: true,
            });
        }
    }
    renderTemplateSelector = () => {

        return (
            <Modal
                key={'detailmodal'}
                width={520}
                height={400}
                footer={<Button key="Next" type={'primary'} className={'my-5'} onClick={this.onTemplateSelectorNext}>Next</Button>}
                className={'flex items-center justify-center p-5'}
                title={'Select a Template for Functional Testing'}
                onCancel={() => this.setState({ isTemplateSelector: false })}
                closable={true}
                open={this.state.isTemplateSelector}>
                <Select style={{width: '500px', paddingTop:'2rem', paddingBottom:'2rem'}} placeholder={'Choose a Template'} value={this.state.selectedTemplate}
                        onChange={this.handleSearchSelect} options={this.state.type_options}/>
            </Modal>

        )
    }

    render() {

        return (

            <div className={this.props.endToolbarSlot ? ' table-page-header--root table-page-header--pro-toolbar-embedded -mx-3 items-center w-full' : ' table-page-header--root -mx-3 items-center w-full'}>
                <div className=" lg:w-auto flex items-center justify-between px-3">


                    <div>
                        {this.props.filterDescription}
                    </div>

                </div>
                <div className={this.props.endToolbarSlot ? ' w-full max-w-full px-3 flex flex-wrap justify-start' : ' w-full max-w-full px-3 flex flex-wrap justify-start mt-2'}>


                    <div className="flex table-page-header-main-row filter-item justify-between w-full min-w-0 items-center">
                        <div className="table-page-header-filter-aux flex flex-wrap items-center justify-start min-w-0 flex-1">
                            {typeof this.props.renderFilter !== "undefined" ? this.props.renderFilter() : ''}

                        </div>

                        {!this.props.isHideRefreshNews && <div className="flex items-center table-page-header-actions">
                            <Space size={8} align="center" wrap className="table-page-header-icon-group">
                            <Tooltip title="Refresh list">
                                <Button
                                    key="button1"
                                    type="default"
                                    shape="circle"
                                    className="table-page-header-icon-btn reload-refresh-btn"
                                    icon={<ReloadOutlined />}
                                    onClick={this.handleRefresh}
                                    aria-label="Refresh list"
                                />
                            </Tooltip>

                            {!this.props.hid_new ? (
                                <Tooltip title="New functional test">
                                    <Button
                                        key="button2"
                                        type="default"
                                        shape="circle"
                                        className="table-page-header-icon-btn"
                                        icon={<PlusOutlined />}
                                        onClick={this.handleOpenNew}
                                        aria-label="New functional test"
                                    />
                                </Tooltip>
                            ) : null}

                            <Popover
                                content={
                                <div className="mt-3 text-center">
                                    <div className="flex justify-between items-center border-b-2 py-2">
                                        <div></div>
                                        <button className="text-blue-600 font-bold uppercase px-6 py-2 rounded" onClick={this.props.resetFilters}>
                                            Reset
                                        </button>
                                    </div>
                                    <div className="mt-2 px-7 py-3">
                                        <div className="mb-4">
                                            {typeof this.props.renderSearches !== "undefined" ? this.props.renderSearches() : ''}
                                        </div>
                                    </div>

                                </div>
                            } trigger="click" placement="bottomRight"
                            >

                                {typeof this.props.resetFilters !== 'undefined' ? (
                                    <Tooltip title="Filter and search">
                                        <Button
                                            key="button4"
                                            type="default"
                                            shape="circle"
                                            icon={
                                                <FilterOutlined
                                                    className={
                                                        this.props.filterHasValue
                                                            ? "text-orange-600"
                                                            : "text-gray-600"
                                                    }
                                                />
                                            }
                                            className="inline-flex items-center font-medium filter-btn table-page-header-icon-btn table-page-header-filter-btn"
                                            onClick={this.handleOpenFilters}
                                            aria-label="Filter and search"
                                        />
                                    </Tooltip>
                                ) : (
                                    <div className={'ml-5 px-3'} />
                                )}

                            </Popover>
                            {this.props.endToolbarSlot ? (
                                <span className="table-page-header-end-slot flex items-center">
                                    {this.props.endToolbarSlot}
                                </span>
                            ) : null}
                            </Space>

                        </div>}

                    </div>

                </div>
                {this.state.isOpenNew ? this.renderDrawer() : ''}
                {this.state.isTemplateSelector ? this.renderTemplateSelector() : ''}

            </div>

        );
    }
}

const mapStateToProps = state => {
    const role = _.get(state, 'Auth.role', {});
    const Role = role && Object.keys(role)[0];
    const facilityContext = getFacilityContext(state);
    return {
        Role: Role,
        companyId: facilityContext.companyId,
        facilityId: facilityContext.facilityId,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeCurrent: (e) => dispatch(appActions.changeCurrent(e)),
        OpenDrawer: (e, id) => dispatch(actions.OpenDrawer(e, id))
    }
}

const ConnectedFunctionTestingPageHeader = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FunctionTestingPageHeader));



export default ConnectedFunctionTestingPageHeader;

